import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Form, FormGroup, Help } from '@/components/Form'

import { Button } from '@/components/Button'
import styles from './AddClientsAsTeamMemberDialog.module.css'
import { ErrorBlock } from '@/components/ErrorBlock'

export interface AddClientsAsTeamMemberDialogProps {
  showing: boolean
  onClose: () => unknown
  onSubmit: () => unknown
  isSubmitPending: boolean
  isSubmitDisabled: boolean
  isSubmitRejected: boolean
  submitError?: unknown
  clientSelect: ReactNode
  clientError?: string
}

export function AddClientsAsTeamMemberDialog({
  showing,
  onClose,
  onSubmit,
  isSubmitPending,
  isSubmitDisabled,
  isSubmitRejected,
  submitError,
  clientSelect,
  clientError,
}: AddClientsAsTeamMemberDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <div className={styles.contentBlock}>
          <ModalSheetContentTitle align="left" compact>
            <span className={styles.title}>Add a supporting client</span>
          </ModalSheetContentTitle>
          <ModalSheetContentDescription align="left" compact>
            <span className={styles.description}>
              The supporting client will have access to the job
            </span>
          </ModalSheetContentDescription>
        </div>

        <ModalSheetContentBlock>
          <Form className={styles.row}>
            <FormGroup className={styles.selectCollaboratorContainer}>
              <div className={styles.addCollaboratorLabel}>Client</div>
              {clientSelect}
              <Help error={clientError} />
            </FormGroup>
          </Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      {isSubmitRejected && <ErrorBlock tackOn="bottom" error={submitError} />}

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            isDisabled={isSubmitPending}
            onPress={onClose}
          />
          <Button
            label="Add Client"
            variant="primary"
            isPending={isSubmitPending}
            testId="add-job-collaborator-as-team-member-submit-button"
            onPress={onSubmit}
            isDisabled={isSubmitDisabled}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}

export interface AddClientsAsTeamMemberSearchItemDetailsProps {
  name?: string
  email?: string
}

export function AddClientsAsTeamMemberSearchItemDetails({
  name,
  email,
}: AddClientsAsTeamMemberSearchItemDetailsProps) {
  return (
    <>
      <div className={styles.collaboratorName}>{name}</div>
      <div className={styles.collaboratorEmail}>{email}</div>
    </>
  )
}
